import { AntDesign } from "@expo/vector-icons";
import { useNavigation } from "@react-navigation/native";
import React, { useCallback } from "react";
import { PageItemType } from "../../../../../../utilities/layout";
import { useTheme } from "@towersystems/roam-common-native";
import { showProductFilteredSearch } from "../../../../screens/ProductFilteredListScreen";
import { SellScreenProps } from "../../../../screens/SellScreen";
import { QuickKey, QuickKeyProps } from "../../../QuickKey";
import { useLayoutProvider } from "../../../../utils/layout";
import { GENERATED_LABEL_PREFIX, MAX_DISPLAYED_FILTERS } from "../../constants";
import { capitalize } from "lodash";

export type FilterQuickKeyProps = QuickKeyProps & {
  label?: string;
  item: PageItemType;
};

export const FilterQuickKey = React.forwardRef<any, FilterQuickKeyProps>(
  (props, ref) => {
    const { getNameFromFilter } = useLayoutProvider();
    const { colors: Colors } = useTheme();
    const {
      label,
      item,
      backgroundImage,
      backgroundColor,
      labelColor,
      ...rest
    } = props;
    const filter = item.config?.filter;

    const color = labelColor
      ? labelColor
      : backgroundImage
      ? Colors.text
      : "rgba(255,255,255,1)";

    const normalizedLabel = React.useMemo(() => {
      if (!filter) {
        return "";
      }

      if (label) {
        return label;
      }

      if (item.config?.label) {
        return item.config?.label;
      }

      const { type, values } = filter;
      if (!values || values.length === 0) {
        return `${GENERATED_LABEL_PREFIX} ${capitalize(type)}`;
      }

      const names = values
        .slice(0, MAX_DISPLAYED_FILTERS)
        .map((id) => getNameFromFilter(type, id));

      return `${GENERATED_LABEL_PREFIX} ${names.join(", ")}`;
    }, []);

    const navigation = useNavigation<SellScreenProps["navigation"]>();

    const onPress = useCallback(() => {
      if (!filter) return;
      showProductFilteredSearch(navigation, {
        filter,
      });
    }, [filter]);

    const iconMarkup = <AntDesign name="filter" size={24} color={color} />;

    return (
      <QuickKey
        ref={ref}
        disabled={false}
        label={normalizedLabel}
        onPress={onPress}
        iconPrimary={iconMarkup}
        backgroundColor={item.config?.color || backgroundColor || Colors.action}
        iconImageUrl={backgroundImage}
        isDestructive={false}
        labelStyle={{
          color: color,
        }}
        {...rest}
      />
    );
  }
);
